var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00012 0.34375C5.98083 0.34375 4.34387 1.98071 4.34387 4C4.34387 5.09415 4.82449 6.07606 5.58612 6.74611C3.55603 7.44573 1.92595 9.00307 1.12797 10.9839L0.900391 11.5488L1.44678 11.8179C3.33175 12.746 5.58627 13.2812 8.00017 13.2812C10.4141 13.2812 12.6686 12.746 14.5536 11.8178L15.1 11.5488L14.8724 10.9839C14.0744 9.00301 12.4443 7.44566 10.4142 6.74606C11.1758 6.07601 11.6564 5.09413 11.6564 4C11.6564 1.98071 10.0194 0.34375 8.00012 0.34375ZM5.65637 4C5.65637 2.70558 6.7057 1.65625 8.00012 1.65625C9.29454 1.65625 10.3439 2.70558 10.3439 4C10.3439 5.29442 9.29454 6.34375 8.00012 6.34375C6.7057 6.34375 5.65637 5.29442 5.65637 4ZM8.00017 11.9688C6.02562 11.9688 4.18379 11.5795 2.60853 10.9074C3.63049 8.97309 5.66223 7.65625 8.00021 7.65625C10.3382 7.65625 12.3699 8.97307 13.3919 10.9074C11.8166 11.5795 9.97475 11.9688 8.00017 11.9688Z",
    fill: "#6C7794"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.2fdb8a736ddb8f5d4808d891912e3b00.svg";
export { ForwardRef as ReactComponent };